<template>
	<div class="btn-group">
		<button type="button" class="btn btn-sm btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
		Teams <span class="caret"></span>
		</button>

		<ul class="dropdown-menu">
			<li v-for="cmpTeam in cmpTeams" v-on:click="toggleTeam(cmpTeam)">
				{{ cmpTeam.name }} ({{ cmpTeam.event_date }})&nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true" v-if="memberInTeam(cmpTeam.id)"></span>
			</li>
		</ul>

	</div>
</template>

<script>

	import { Message } from 'element-ui';
	import lang from 'element-ui/lib/locale/lang/en';
	import locale from 'element-ui/lib/locale';
	locale.use(lang);

	export default {
			props: ['member', 'teams', 'member_teams'],
			components: { Message },
			data: function () {
					return {
							cmpTeams: this.teams,
							cmpMember: this.member,
							cmpMemberTeams: this.member_teams
					}
			},

			mounted() {
					console.log('TeamMemberToggle component mounted.');
			},
			methods: {
				toggleTeam(theTeam) {
					console.log('Toggling Team ' + theTeam.id + ' for member ' + this.cmpMember.id);
					var wasInTeam = this.memberInTeam(theTeam.id);
					axios.post('/api/members/teams/toggle', {
						team_id: theTeam.id,
						member_id: this.cmpMember.id
					}).then((response) => {
						console.log(response);
						if (wasInTeam === true) {
							this.$message({message: this.cmpMember.first_name + ' ' + this.cmpMember.last_name + ' removed from the ' + theTeam.name + ' team successfully.', type: 'warning'});
						}
						else {
							this.$message({message: this.cmpMember.first_name + ' ' + this.cmpMember.last_name + ' added to the ' + theTeam.name + ' team successfully.', type: 'success'});
						}
						this.cmpMemberTeams = response.data;
					}).catch((error) => {
						this.handleHTTPError(error);
					});
				},
				memberInTeam(team_id) {
					for (var cmpTeam of this.cmpMemberTeams) {
						if (cmpTeam.id == team_id) {
							return true;
						}
					}
					return false;
				},
				handleHTTPError(error) {
						if (error.response) {
							// The request was made and the server responded with a status code
							// that falls out of the range of 2xx
							console.log(error.response.data); // Error message
							console.log(error.response.status);
							console.log(error.response.headers);
							this.$message({message: 'Error: ' + error.response.data, type: 'error'});
						} else if (error.request) {
							// The request was made but no response was received
							// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
							// http.ClientRequest in node.js
							console.log(error.request);
							this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
						} else {
							// Something happened in setting up the request that triggered an Error
							console.log('Error', error.message);
							this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
						}
						console.log(error.config);
				},
			}
	}

</script>